<template>
  <div>
    <FormBox image>
      <template>
        <p class="text-gray-700 pb-20 pb-md-30">
          Stop looking for a job, let the job come to you.
        </p>

        <h1>
          The best startup jobs<br />
          straight to your inbox
        </h1>
      </template>
    </FormBox>

    <Container spacing="large" class="mb-20">
      <TextBlock class="mt-0">
        <h3 class="fs40 mb-10">Easy as one two three</h3>
        <p class="text-gray-700 pb-30 pb-lg-40">
          We strive to make the job search easier for you. It’s our promise.
        </p>

        <b-row class="steps">
          <b-col md="4" class="pb-30">
            <img
              class="icon"
              src="~/assets/components/subscribe/jobs.svg"
              alt="unique jobs"
            />
            <h5 class="pt-30">+1000 unique jobs</h5>
            <p class="pt-10">
              The most exciting new startup jobs in the Nordics.
            </p>
          </b-col>
          <b-col md="4" class="pb-30">
            <img
              class="icon"
              src="~/assets/components/subscribe/hand.svg"
              alt="hand"
            />
            <h5 class="pt-30">1-click application</h5>
            <p class="pt-10">
              No long registration forms, just fill in your details, your resume
              and you’re done.
            </p>
          </b-col>
          <b-col md="4" class="pb-30">
            <img
              class="icon"
              src="~/assets/components/subscribe/linkedin.svg"
              alt="linkedin logo"
            />
            <h5 class="pt-30">Autofill with LinkedIn</h5>
            <p class="pt-10">
              No time? Use your linkedin profile and make your application even
              faster.
            </p>
          </b-col>
        </b-row>
      </TextBlock>
    </Container>

    <FormBox job-roles job-position-types full-location class="hidden-md-down">
      <template>
        <h1 class="fs40 pb-30">
          Need your job to be more specific? We got you.
        </h1>

        <p class="text-gray-700 fs20">
          Subscribe to our job digest emails and we’ll send the best startup
          jobs to your email, so you don’t have to spend time browsing.
        </p>
      </template>
    </FormBox>

    <Container spacing="large" class="mb-20">
      <TextBlock class="mt-0">
        <h3 class="fs40 fs-sm-32 mb-10">
          Change your life, <br />Get a new job
        </h3>
        <p class="text-gray-700 pb-30 pb-lg-40">
          Find a job you enjoy doing, and you will never have to work a day in
          your life.
        </p>

        <b-row>
          <b-col lg="6">
            <Testimonial
              :photo="require('~/assets/components/subscribe/kim.jpg')"
              quote="“I built my marketing career through the Hub”"
              name="Kim"
              position="CMO"
              company="Maria01"
            />
          </b-col>
          <b-col lg="6">
            <Testimonial
              :photo="require('~/assets/components/subscribe/polina.jpg')"
              quote="“Thanks to the Hub, I work now for one of the best Nordic startups”"
              name="Polina"
              position="Communication Specialist"
              company="Chaos Architects"
            />
          </b-col>
        </b-row>
      </TextBlock>
    </Container>
  </div>
</template>

<script>
import FormBox from '@/components/subscribe/FormBox'
import Testimonial from '@/components/subscribe/Testimonial'
import Container from '@/components/Container'
import TextBlock from '@/components/TextBlock'
import { buildMetaHead } from '@/helpers/meta'

export default {
  name: 'PageEmailSignUp',
  components: { FormBox, Testimonial, Container, TextBlock },
  head() {
    return buildMetaHead({
      title: 'The best startup jobs straight to your inbox',
      description:
        'Never miss an opportunity again; subscribe to our job digest emails and get the best startup and scale-up jobs in the Nordics customized to your needs and delivered directly to your inbox.',
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/signup.jpg'
    })
  }
}
</script>

<style lang="scss" scoped>
.steps {
  .icon {
    height: 2.5rem;
  }

  h5 {
    color: $gray-900;
  }

  p {
    max-width: 260px;
  }
}
</style>
